const styles = {
  root: {
    marginTop: 20,
    textAlign: 'center',
    width: '100%'
  }
};

export default styles;